<template>
  <div>
    <!--1. 下载-->
    <div class="mb15" v-for="(item, index) in loadList" :key="index">
      <div class="flex align-items-center mb15">
        <img class="img-box-2" :src="item.icon" alt />
        <div class="text1">
          {{ item.title }}
          <span style="color: #f6350f">*</span>
        </div>
      </div>
      <div>
        <a-upload
          :file-list="item.fileList"
          :accept="item.accept"
          :remove="(file, fileList) => handleRemove(file, fileList, index)"
          :customRequest="()=>{return}"
          :before-upload="
            (file, fileList) => beforeUpload(file, fileList, index, item) 
          "
           :disabled="(item.loading)"
        >
          <a-button
            :disabled="
              ($parent &&
                $parent.editInfo &&
                $parent.editInfo.type == 'preview') ||
              item.loading || (item.id == 6 ? item.fileList.length > 1 : item.fileList.length > 0)"
            :loading="item.loading"
          >
            <a-icon type="upload" />上传附件
          </a-button>
          <div style="width:600px;height:auto;">
            <a-progress
              v-if="item.uploadPercent > 0"
              :percent="item.uploadPercent"
              status="active"
              :stroke-width="5"
            />
          </div>
        </a-upload>
        <a-upload
            v-if="item.id=='1'"
            name="avatar"
            accept=".png,.jpg,.jpeg"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="false"
            :remove="(file, fileList) => handleRemove1(file, fileList, index)"
            :customRequest="()=>{return}"
            :before-upload="
            (file, fileList) => beforeUpload1(file, fileList, index, item) 
            "
            :disabled="(item.loadings)"
          >
            <img v-if="imageUrl" style="width:128px;height:128px;" :src="baseURL+imageUrl" alt="avatar" />
            <div v-else>
              <a-icon :type="item.loadings ? 'loading' : 'plus'" />
              <div class="ant-upload-text">
                上传封面图片
              </div>
            </div>
        </a-upload>
      </div>
      <div class="text2">{{ item.remarks }}</div>
    </div>
    <div class="big-box flex">
      <div class="submit-btn btn-bg-1" @click="option(1)">上 一 步</div>
      <div class="submit-btn btn-bg-2" :class="{ 'btn-disabled': isUploading }" @click="save">保存</div>
      <div class="submit-btn btn-bg-2" :class="{ 'btn-disabled': isUploading }" @click="submit" v-if="$store.state.role !== 'draw-role'">提交</div>
    </div>
  </div>
</template>

<script>
import { fileUps, postAction,fileUp} from "@/api/index";
import { pieviewURL } from "../../utils/request";
import axios from "axios";
// 目标文件引入方式
import { calculateFileMD5 } from "@/utils/md5-util.js";
import { getAction } from "../../api";
import SparkMD5 from 'spark-md5';
import { baseURL } from "@/utils/request.js";
export default {
  name: "",
  components: {},
  props: {
    loadList: {
      type: Array
    },
    oldApplyFiles1: {
      type: Array
    },
    imageUrl: {
      type: String
    }
  },
  data() {
    return {
      baseURL,
      applyFiles: [],
      loading: false,
      type1: false,
      type2: false,
      type3: false,
      path: process.env.BASE_URL,
      loadList1: [
        {
          title: "教学视频",
          id: 1,
          remarks:
            "注：请上传MP4格式的文件，文件大小不超过1000M,视频时长10-15分钟,仅能上传一个文件。",
          accept: ".mp4",
          icon: require("../../assets/images/img24.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
          uploadPercent: 0
        },
        {
          title: "教学设计",
          id: 2,
          remarks: "注：请上传pdf/docx格式的文件,仅能上传一个文件。",
          accept: ".pdf,.docx",
          icon: require("../../assets/images/img24.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
          uploadPercent: 0
        },
          {
          title: "微课逐字稿",
          id: 3,
          remarks: "注：请上传pdf格式的文件,仅能上传一个文件。",  
          accept: ".pdf",
          icon: require("../../assets/images/img24.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
          uploadPercent: 0
        },
          {
          title: "微课课件",
          id: 7,
          remarks: "注：请上传pdf格式的文件，仅能上传一个文件。",
          accept: ".pdf",
          icon: require("../../assets/images/img24.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
          uploadPercent: 0
        },
          {
          title: "参赛作品信息表",
          id: 8,
          remarks: "注：请上传pdf格式的文件，仅能上传一个文件。",
          accept: ".pdf",
          icon: require("../../assets/images/img24.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
          uploadPercent: 0
        },
        {
          title: "参赛作品推荐表",
          id: 6,
          remarks: "注：请上传pdf/jpg/jpeg/png格式的文件,可上传1个pdf和1张图片。",
          accept: ".pdf,.jpg,.jpeg,.png",
          icon: require("../../assets/images/img24.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
          uploadPercent: 0
        },
      ]
    };
  },
  computed: {
    // 是否有文件正在上传（附件或封面图片），上传中禁止点击保存/提交
    isUploading() {
      return (this.loadList || []).some(item => item.loading || item.loadings);
    }
  },
  watch: {},
  created() {},
  destroyed() {
    //	 sessionStorage.removeItem('qbsj');
  },
  mounted() {
    if (
      this.oldApplyFiles1 && this.oldApplyFiles1.length == 0 &&
      sessionStorage.getItem("qbsj") != undefined
    ) {
      let arr = JSON.parse(sessionStorage.getItem("qbsj"));
      for (let i = 0; i < this.loadList1.length; i++) {
        (arr.applyFiles || []).map(item1 => {
          if (this.loadList1[i].id == item1.fileType) {
            let newItem = {};
            let newApplyFiles = {};
            newApplyFiles.filePath = item1.filePath;
            newApplyFiles.fileType = item1.fileType;
            newItem.uid = item1.id;
            //  item1.filePath.slice()
            let newName = item1.filePath.slice(
              item1.filePath.lastIndexOf("/") + 1
            );
            let firstname = newName.slice(0, newName.lastIndexOf("_"));
            let lastname = newName.slice(newName.lastIndexOf("."));
            newItem.name = firstname + lastname;
            newItem.name1 = newName;
            newItem.fileType = item1.fileType;
            newItem.url = pieviewURL + newName;
            //          this.loadList1[i].fileList.push(newItem);
            this.loadList[i].fileList.push(newItem);
            this.oldApplyFiles1.push(newApplyFiles);
          }
        });
      }
    }
    //	  console.log(sessionStorage.getItem('qbsj'),this.loadList,this.oldApplyFiles1);
  },
  methods: {
    // 组装待提交的文件列表：按 filePath 去重，避免重复保存/返回后再保存时旧文件被重复提交
    buildApplyFiles() {
      const map = {};
      [...(this.applyFiles || []), ...(this.oldApplyFiles1 || [])].forEach(item => {
        if (item && item.filePath && !map[item.filePath]) {
          map[item.filePath] = item;
        }
      });
      return Object.keys(map).map(key => map[key]);
    },
    handleRemove(file, fileList, fileindex) {
      this.applyFiles = this.applyFiles.filter(item => {
        if (item.filePath.indexOf(file.name1) === -1) {
          return item;
        }
      });
      const index = this.loadList[fileindex].fileList.indexOf(file);
      this.$emit("deleteFile", file);
      const newFileList = this.loadList[fileindex].fileList.slice();
      newFileList.splice(index, 1);
      this.loadList[fileindex].fileList = newFileList;
    },
    handleRemove1(file, fileList, fileindex) {
      this.imageUrl='';
    },
    beforeUpload(file, fileList, fileindex, item) {
      this.$regFile(file, fileList, fileindex, item);
    },
    beforeUpload1(file, fileList, fileindex, item) {
      // console.log(file);
      if(file.type == 'image/png' || file.type == 'image/jpg' || file.type == 'image/jpeg'){
        if (file.size > 1024 * 1024 * 5) {
            this.$message.error("请上传大小在 5M 以内的文件");
            return false;
        } 
      }else{
        this.$message.warn('请上传正确格式的文件');
        return false;
      }
      this.handleUpload1(fileindex, file);
      // if (item.accept.toLowerCase() == '.mp4' && file.type == 'video/mp4') {
      //     if (file.size > 1024 * 1024 * 1000) {
      //       this.$message.error("请上传大小在 1000M 以内的文件");
      //     } 
      //  }
    },
    handleUpload1(fileindex, file) {
      this.loadList[fileindex].loadings = true;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('biz', 'linxuan');
      fileUp(formData).then((res) => {
        if (res.code === 200) {
          this.$message.success(`上传成功`);
          // let fileItem = {};
          // fileItem.filePath = res.result.path;
          // fileItem.fileType = this.loadList[fileindex].id;
          // fileItem.uid = file.uid;
          // this.applyFiles.push(fileItem);
          // this.$emit('upDataFile', fileItem, fileindex, 1);
          this.imageUrl=res.result.path;
          this.loadList[fileindex].loadings = false;
//        console.log(fileItem, '上传文件');
        } else {
          this.$message.error('上传失败');
        }
      });
    },
    // handleUpload(fileindex, file) {
    //   this.loadList[fileindex].loading = true;
    //   this.loadList[fileindex].uploadPercent = 0;
    //   const formData = new FormData();
    //   formData.append('file', file);
    //   formData.append('biz', 'linxuan');
    //    fileUps(formData, (percent) => {
    //       this.loadList[fileindex].uploadPercent = percent;
    //     }).then((res) => {
    //     if (res.code === 200) {
    //       this.$message.success(`上传成功`);
    //       let fileItem = {};
    //       fileItem.filePath = res.result.path;
    //       fileItem.fileType = this.loadList[fileindex].id;
    //       fileItem.uid = file.uid;
    //       this.applyFiles.push(fileItem);
    //       this.$emit('upDataFile', fileItem, fileindex, 1);
    //       this.loadList[fileindex].loading = false;
    //           this.loadList[fileindex].uploadPercent = 0; // 上传完成后重置进度
    //     } else {
    //       this.$message.error('上传失败');
    //       this.loadList[fileindex].loading = false;
    //       this.loadList[fileindex].uploadPercent = 0; // 上传完成后重置进度
    //     }
    //   }).catch(() => {
    //     this.loadList[fileindex].loading = false;
    //     this.loadList[fileindex].uploadPercent = 0;
    //   });
    // },
    processFile(file) {
      const CHUNK_SIZE = 10 * 1024 * 1024;
      const chunkCount = Math.ceil(file.size / CHUNK_SIZE);
      const chunks = [];

      for (let i = 0; i < chunkCount; i++) {
        const start = i * CHUNK_SIZE;
        const end = Math.min(file.size, start + CHUNK_SIZE);
        chunks.push({
          index: i,
          chunk: file.slice(start, end)
        });
      }
      return chunks;
    },
    // 带进度显示的文件MD5计算
    async calculateFileMD5WithProgress(file, onProgress) {
      return new Promise((resolve, reject) => {
        const blobSlice =
          File.prototype.slice ||
          File.prototype.mozSlice ||
          File.prototype.webkitSlice;
        const chunkSize = 300 * 1024 * 1024; // 5MB 分块
        const chunks = Math.ceil(file.size / chunkSize);
        let currentChunk = 0;
        const spark = new SparkMD5.ArrayBuffer();
        const fileReader = new FileReader();

        fileReader.onload = e => {
          spark.append(e.target.result);
          currentChunk++;

          // 更新MD5计算进度（占总进度的20%）
          // const md5Progress = Number(Math.min(20, (currentChunk / chunks) * 20)).toFixed(1);
          // onProgress && onProgress(md5Progress);

          if (currentChunk < chunks) {
            loadNext();
          } else {
            resolve(spark.end());
          }
        };

        fileReader.onerror = () => {
          reject(new Error("文件读取失败"));
        };

        const loadNext = () => {
          const start = currentChunk * chunkSize;
          const end = Math.min(start + chunkSize, file.size);
          fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
        };

        loadNext();
      });
    },
    // 单个分片上传
    uploadOneChunk(index, chunk, uploadId, fileMd5) {
      const chunkFormData = new FormData();
      chunkFormData.append("chunk", chunk, `chunk_${index}`);
      chunkFormData.append("index", index);
      chunkFormData.append("uploadId", uploadId);
      chunkFormData.append("fileMd5", fileMd5);
      return postAction("/upload/chunk?fileId=" + uploadId, chunkFormData);
    },
    // 限制并发数的批量执行：同一时刻最多 limit 个任务在飞
    async runWithConcurrency(items, limit, worker) {
      let cursor = 0;
      const runner = async () => {
        while (cursor < items.length) {
          const item = items[cursor++];
          await worker(item);
        }
      };
      await Promise.all(
        Array.from({ length: Math.min(limit, items.length) }, () => runner())
      );
    },
    async uploadChunksWithRetry(chunks, uploadId, fileMd5, onProgress) {
        const CHUNK_CONCURRENCY = 3; // 分片并发数，不宜超过浏览器同域名连接数上限
        const failedChunks = [];
        let completedChunks = 0;
        const totalChunks = chunks.length;

        const reportProgress = () => {
          const progress = Math.min(99, (completedChunks / totalChunks) * 100);
          onProgress && onProgress(Number(progress.toFixed(1)));
        };

        // 首次上传尝试：限制并发上传，单个分片失败不影响其他分片
        await this.runWithConcurrency(chunks, CHUNK_CONCURRENCY, async ({ index, chunk }) => {
          try {
            await this.uploadOneChunk(index, chunk, uploadId, fileMd5);
            completedChunks++;
          } catch (error) {
            console.error(`分片${index}上传失败:`, error);
            failedChunks.push({ index, chunk });
          }
          reportProgress();
        });

        // 失败分片重试（最多3次）
        let retryCount = 0;
        while (failedChunks.length > 0 && retryCount < 3) {
          retryCount++;
          console.log(`开始第${retryCount}次重试，剩余${failedChunks.length}个分片`);
          
          const retryItems = failedChunks.splice(0, failedChunks.length);
          await this.runWithConcurrency(retryItems, CHUNK_CONCURRENCY, async ({ index, chunk }) => {
            try {
              await this.uploadOneChunk(index, chunk, uploadId, fileMd5);
              completedChunks++;
              reportProgress();
            } catch (error) {
              console.error(`分片${index}第${retryCount}次重试失败:`, error);
              failedChunks.push({ index, chunk });
            }
          });
        }

        return failedChunks.length === 0;
    },
    async enhancedUpload(file, formData, onProgress, durationRange) {
      // 视频时长区间（[最小,最大]，单位秒），由后端在文件落盘后立即校验
      const hasDurationRange =
        Array.isArray(durationRange) && durationRange.length == 2;
      if (file.size <= 400 * 1024 * 1024) {
        // 小文件直接上传
        if (hasDurationRange) {
          formData.append("videoMinSeconds", durationRange[0]);
          formData.append("videoMaxSeconds", durationRange[1]);
        }
        return fileUps(formData, percent => {
          onProgress && onProgress(percent);
        });
      } else {
        // console.log("wwwww");
        const fileMd5 = await this.calculateFileMD5WithProgress(
          file,
          onProgress
        );
        console.log(fileMd5);
        // 2. 初始化上传
        const initResponse = await getAction("/upload/init", {
          fileName: file.name,
          fileMd5
        });
        // 检查初始化响应
        console.log(initResponse,"555");
        if (
          !initResponse ||
          !initResponse.result 
        ) {
          throw new Error("初始化上传失败：未获取到uploadId");
        }
       

        const uploadId = initResponse.result;
        const chunks = this.processFile(file);
        // const totalChunks = chunks.length;
        // const failedChunks = [];
        // let completedChunks = 0;
      
        // 3. 顺序上传分块（避免并行请求过多）
        await  this.uploadChunksWithRetry(chunks,uploadId,fileMd5,onProgress)
        // for (const { index, chunk } of chunks) {
        //   try {
        //   // console.log(chunk,"555");
        //   const chunkFormData = new FormData();
        //   chunkFormData.append("chunk", chunk, `chunk_${index}`);
        //   chunkFormData.append("index", index);
        //   chunkFormData.append("uploadId", uploadId);
        //   chunkFormData.append("fileMd5", fileMd5);

        //   await postAction("/upload/chunk", chunkFormData);
        //   completedChunks++;
        //     } catch (error) {
        //   console.error(`分片${index}上传失败:`, error);
        //   failedChunks.push({ index, chunk });
        // }
        //   const chunkProgress = Number(Math.min(
        //     99,
        //     (completedChunks / totalChunks) * 100).toFixed(1)
        //   );
        //   onProgress && onProgress(chunkProgress);
        // }


        // 4. 合并分块
        const mergeResponse = await getAction("/upload/merge", {
          fileName: file.name,
          uploadId,
          fileMd5,
          biz:"linxuan",
          fileId:uploadId,
          ...(hasDurationRange
            ? {
                videoMinSeconds: durationRange[0],
                videoMaxSeconds: durationRange[1]
              }
            : {})
        });

        // 上传完成
        onProgress && onProgress(100);
        // console.log(mergeResponse,"2222");
        return mergeResponse;

        // const { data: result } = await getAction('/upload/init', {
        //       fileName: file.name,
        //       fileMd5: await calculateFileMD5(file) // 文件MD5计算
        // });
        // console.log(result);
        // const chunks = this.processFile(file);
        // const total = chunks.length;
        // let uploaded = 0;

        // await Promise.all(chunks.map((chunk, index) => {
        // const formData = new FormData();
        // formData.append('chunk', chunk, `chunk_${index}`);
        // formData.append('index', index);
        // formData.append('uploadId', result);

        // formData.append('fileMd5',calculateFileMD5(chunk));

        //     return postAction('/upload/chunk', formData, {
        //         onUploadProgress: progress => {
        //             const percent = ((uploaded * 100) / total).toFixed(1);
        //             onProgress && onProgress(percent);
        //         }
        //     }).then(() => uploaded++);
        // }));

        // try {
        //   const { data } = await postAction('/upload/merge', {
        //     fileName: file.name,
        //     uploadId:result,
        //     fileMd5
        //   });
        //   return data;
        // } catch (e) {
        //   return { code: 500, message: '合并失败' };
        // }
        // 大文件分片上传
        // const chunkCount = Math.ceil(file.size / CHUNK_SIZE);
        // let uploadedSize = 0;
        // for (let i = 0; i < chunkCount; i++) {
        //   const start = i * CHUNK_SIZE;
        //   const end = Math.min(file.size, start + CHUNK_SIZE);
        //   const chunk = file.slice(start, end);

        //   const chunkForm = new FormData();
        //   chunkForm.append('file', chunk);
        //   chunkForm.append('chunkIndex', i);
        //   chunkForm.append('totalChunks', chunkCount);
        //   chunkForm.append('fileId', file.uid); // 使用文件唯一标识

        //   await chunkUpload(chunkForm, (chunkPercent) => {
        //     const overallPercent = Math.round(
        //       (uploadedSize + chunkPercent * (end - start) / 100) / file.size * 100
        //     );
        //     onProgress && onProgress(overallPercent);
        //   });

        //   uploadedSize += end - start;
        // }
        // return { code: 200, result: { path: 'merged_file_path' } };
      }
    },
    async handleUpload(fileindex, file) {
      this.loadList[fileindex].loading = true;
      this.loadList[fileindex].uploadPercent = 0;

      const formData = new FormData();
      formData.append("file", file);
      formData.append("biz", "linxuan");

      try {
        // 视频时长区间随请求带给后端，文件落盘后由后端立即校验
        const res = await this.enhancedUpload(
          file,
          formData,
          percent => {
            this.loadList[fileindex].uploadPercent = percent;
          },
          this.loadList[fileindex].videoDurationRange
        );
        // console.log(1111);
        if (res.code === 200) {
          this.$message.success(`上传成功`);
          console.log(file);
          let fileItem = {
            filePath: res.result.path,
            fileType: this.loadList[fileindex].id,
            uid: file.uid
          };
          this.applyFiles.push(fileItem);
          this.$emit("upDataFile", fileItem, fileindex, 1);
        } else {
          // 后端校验不通过（如视频时长超范围）时展示具体原因
          this.$message.error(res.message || "上传失败");
        }
      } catch (error) {
        this.$message.error("上传异常: " + error.message);
      } finally {
        this.loadList[fileindex].loading = false;
        this.loadList[fileindex].uploadPercent = 0;
      }
    },
    save() {
      this.submitLoading = this.loadList.filter(item => {
        if (item.loading || item.loadings) {
          return item;
        }
      });
      if (this.submitLoading && this.submitLoading.length >= 1) {
        this.$message.warning("文件正在上传，请上传成功后提交");
      } else {
        //下面是判断必填代码
        //      console.log(this.loadList,this.applyFiles);
        //      if(this.loadList[0].fileList.length==0){
        //      	this.$message.error('请上传'+this.loadList[0].title);
        //      	 return false;
        //      }else if(this.loadList[1].fileList.length==0){
        //      	this.$message.error('请上传'+this.loadList[1].title);
        //      	 return false;
        //      }else if(this.loadList[2].fileList.length==0){
        //      	this.$message.error('请上传'+this.loadList[2].title);
        //      	return false;
        //      }
        this.applyFiles = this.buildApplyFiles();
        this.$emit("submit", this.loadList, this.applyFiles, 0,this.imageUrl);
      }
    },
    download() {
      window.location.href = this.path + "附件2：申请表.docx";
    },
    submit() {
      this.submitLoading = this.loadList.filter(item => {
        if (item.loading || item.loadings) {
          return item;
        }
      });
      if (this.submitLoading && this.submitLoading.length >= 1) {
        this.$message.warning("文件正在上传，请上传成功后提交");
      } else {
        //下面是判断必填代码
        // console.log(this.loadList,this.applyFiles);
        // if(this.loadList[0].fileList.length==0 && this.loadList[1].fileList.length==0){
        // 	this.$message.error('请上传'+this.loadList[0].title+"或"+this.loadList[1].title);
        // 	 return false;
        // }else if(this.loadList[1].fileList.length==0){
        // 	this.$message.error('请上传'+this.loadList[1].title);
        // 	return false;
        // }else if(this.loadList[1].fileList.length==1){
        //   this.$message.error('请上传'+this.loadList[1].title+'两个文件');
        //   return false;
        // }else if(this.loadList[1].fileList.length>2){
        //   this.$message.error(this.loadList[1].title+'最多上传两个文件，请删除相应的文件！');
        //   return false;
        // }else if(this.loadList[2].fileList.length==0){
        // 	this.$message.error('请上传'+this.loadList[2].title);
        // 	return false;
        // }
        // 分社(school-role)审核学校作品提交时，不再校验封面图片
        const skipCoverCheck = this.$store.state.role === "school-role";
        if (this.loadList[0].fileList.length == 0) {
          this.$message.error("请上传" + this.loadList[0].title);
          return false;
        } else if(!skipCoverCheck && (!this.imageUrl || this.imageUrl==null || this.imageUrl=='' || this.imageUrl=='undefined')){
          this.$message.error("请上传微课的封面图片");
          return false;
        }else if (this.loadList[1].fileList.length == 0) {
          this.$message.error("请上传" + this.loadList[1].title);
          return false;
        }else if (this.loadList[2].fileList.length == 0) {
          this.$message.error("请上传" + this.loadList[2].title);
          return false;
        }else if (this.loadList[3].fileList.length == 0) {
          this.$message.error("请上传" + this.loadList[3].title);
          return false;
        }else if (this.loadList[4].fileList.length == 0) {
          this.$message.error("请上传" + this.loadList[4].title);
          return false;
        }else if (this.loadList[5].fileList.length == 0) {
          this.$message.error("请上传" + this.loadList[5].title);
          return false;
        }
        this.applyFiles = this.buildApplyFiles();
        this.$emit("submit", this.loadList, this.applyFiles, 1,this.imageUrl);
      }
    },
    option(type) {
      //type === 1 上一步 | type === 2 下一步
      this.loadList.map(item => {
        let newItem = item.fileList.filter(item1 => {
          if (item.fileList.length != 0 && item1 && item1.fileType == 1) {
            this.type1 = true;
          } else if (
            item.fileList.length != 0 &&
            item1 &&
            item1.fileType == 2
          ) {
            this.type2 = true;
          } else if (
            item.fileList.length != 0 &&
            item1 &&
            item1.fileType == 3
          ) {
            this.type3 = true;
          }
        });
        return newItem;
      });
      this.applyFiles = this.buildApplyFiles();
      if (type === 1) {
        this.$emit("upStep", this.loadList, this.applyFiles,this.imageUrl);
      } else {
        this.$emit("downStep", this.loadList, this.applyFiles);
      }
    }
  }
};
</script>

<style scoped lang="scss">
// 文件上传中，保存/提交按钮不可点击
.btn-disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}
.text1 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.mb15 {
  margin-bottom: 15px;
}
.text2 {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin-top: 14px;
  margin-bottom: 15px;
}
.img-box {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}
.img-box-2 {
  width: 19px;
  height: 19px;
  margin-right: 10px;
}
.img-box-4 {
  width: 12px;
  height: 12px;
  margin-right: 10px;
  margin-bottom: 5px;
}
.submit-btn {
  width: 116px;
  height: 40px;
  margin: 0 auto;
  color: #fff;
  background: #9A0B00;
  line-height: 38px;
  text-align: center;
  border-radius: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  cursor: pointer;
}

.big-box {
  width: 500px;
  margin: 100px auto 0px;
}
.avatar-uploader{
  margin-top:18px;
  width: 144px;
  height: 144px;
}
/deep/ .ant-upload.ant-upload-select-picture-card{
  width: 144px;
  height: 144px;
}
</style>
